import script from "./JobDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobDetails.vue?vue&type=script&setup=true&lang=ts"

import "./JobDetails.vue?vue&type=style&index=0&id=1840bb08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1840bb08"]])

export default __exports__